var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "06a431ea-d99e-4aa4-a71a-74169910de90"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "09490849-8b97-47b6-b263-135ad50bdde4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 12.39 -12.39 0 583.43 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -52)",
    d: "M 80.738 22.116 L 19.262 22.116 C 16.679000000000002 22.116 14.61 24.184 14.61 26.77 L 14.61 63.428 C 14.61 65.961 16.68 68.08 19.262 68.08 L 45.218 68.08 L 61.55500000000001 81.88499999999999 L 55.402 68.08 L 80.738 68.08 C 83.271 68.08 85.39 65.961 85.39 63.428 L 85.39 26.77 C 85.391 24.184 83.271 22.116 80.738 22.116 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -12.39 12.39 0 498.14 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -52)",
    d: "M 80.738 22.116 L 19.262 22.116 C 16.679000000000002 22.116 14.61 24.184 14.61 26.77 L 14.61 63.428 C 14.61 65.961 16.68 68.08 19.262 68.08 L 45.218 68.08 L 61.55500000000001 81.88499999999999 L 55.402 68.08 L 80.738 68.08 C 83.271 68.08 85.39 65.961 85.39 63.428 L 85.39 26.77 C 85.391 24.184 83.271 22.116 80.738 22.116 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(29.64 0 0 29.64 558.85 523.76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,37,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-6.5, -7.5)",
    d: "M 0.928571 13.5938 C 0.928571 13.9667 1.07532 14.3244 1.33653 14.5881 C 1.59774 14.8518 1.95202 15 2.32143 15 L 10.6786 15 C 11.048 15 11.4023 14.8518 11.6635 14.5881 C 11.9247 14.3244 12.0714 13.9667 12.0714 13.5938 L 12.0714 3.75 L 0.928571 3.75 L 0.928571 13.5938 Z M 8.82142 6.09375 C 8.82142 5.96943 8.87034 5.8502 8.95741 5.7623 C 9.04448 5.67439 9.16257 5.625 9.28571 5.625 C 9.40885 5.625 9.52694 5.67439 9.61401 5.7623 C 9.70108 5.8502 9.75 5.96943 9.75 6.09375 L 9.75 12.6563 C 9.75 12.7806 9.70108 12.8998 9.61401 12.9877 C 9.52694 13.0756 9.40885 13.125 9.28571 13.125 C 9.16257 13.125 9.04448 13.0756 8.95741 12.9877 C 8.87034 12.8998 8.82142 12.7806 8.82142 12.6563 L 8.82142 6.09375 Z M 6.03571 6.09375 C 6.03571 5.96943 6.08463 5.8502 6.1717 5.7623 C 6.25877 5.67439 6.37686 5.625 6.5 5.625 C 6.62313 5.625 6.74123 5.67439 6.8283 5.7623 C 6.91537 5.8502 6.96428 5.96943 6.96428 6.09375 L 6.96428 12.6563 C 6.96428 12.7806 6.91537 12.8998 6.8283 12.9877 C 6.74123 13.0756 6.62313 13.125 6.5 13.125 C 6.37686 13.125 6.25877 13.0756 6.1717 12.9877 C 6.08463 12.8998 6.03571 12.7806 6.03571 12.6563 L 6.03571 6.09375 Z M 3.25 6.09375 C 3.25 5.96943 3.29891 5.8502 3.38598 5.7623 C 3.47306 5.67439 3.59115 5.625 3.71428 5.625 C 3.83742 5.625 3.95551 5.67439 4.04258 5.7623 C 4.12965 5.8502 4.17857 5.96943 4.17857 6.09375 L 4.17857 12.6563 C 4.17857 12.7806 4.12965 12.8998 4.04258 12.9877 C 3.95551 13.0756 3.83742 13.125 3.71428 13.125 C 3.59115 13.125 3.47306 13.0756 3.38598 12.9877 C 3.29891 12.8998 3.25 12.7806 3.25 12.6563 L 3.25 6.09375 Z M 12.5357 0.937505 L 9.05357 0.937505 L 8.7808 0.389653 C 8.72302 0.272529 8.63401 0.174006 8.52379 0.105169 C 8.41358 0.0363316 8.28652 -0.0000887099 8.15692 0.00000513654 L 4.84018 0.00000513654 C 4.71087 -0.000496734 4.58403 0.0357877 4.4742 0.104701 C 4.36438 0.173615 4.276 0.272371 4.21919 0.389653 L 3.94643 0.937505 L 0.464286 0.937505 C 0.341149 0.937505 0.223057 0.986891 0.135986 1.0748 C 0.0489157 1.16271 0 1.28193 0 1.40625 L 0 2.34375 C 0 2.46807 0.0489157 2.5873 0.135986 2.67521 C 0.223057 2.76312 0.341149 2.8125 0.464286 2.8125 L 12.5357 2.8125 C 12.6588 2.8125 12.7769 2.76312 12.864 2.67521 C 12.9511 2.5873 13 2.46807 13 2.34375 L 13 1.40625 C 13 1.28193 12.9511 1.16271 12.864 1.0748 C 12.7769 0.986891 12.6588 0.937505 12.5357 0.937505 Z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.207a27632eefcdc4da6c52385cea6d4e.svg";
export { ForwardRef as ReactComponent };